module.exports = __webpack_public_path__ + "app/assets/images/woman5-3688e2fb4ffd46aa1ba3658f9eb18f24.jpg";